// Match the server's business-field allowlist; never send token/contact columns.
export const aiFields = [
  'name', 'keyword', 'status', 'labels', 'channel', 'type', 'region', 'area', 'total',
  'price', 'buy_type', 'income', 'manager', 'industry', 'job', 'job_time', 'buy_house',
  'financial', 'introduce', 'money_time', 'house_region', 'discount', 'wechat_status',
  'wechat_add_time', 'subject_id', 'project_id', 'subjects', 'come_time', 'log_time',
  'source_channel_v2', 'total_budget_range', 'price_acceptance_level', 'purpose_v2'
]
export function aiProfile(info) {
  const result = {}
  aiFields.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(info || {}, key)) {
      result[key] = info[key] === '' ? null : info[key]
    }
  })
  return result
}
export function validAiTime(value) {
  const text = String(value || '').replace(' ', 'T').slice(0, 16)
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(text)) return ''
  const date = new Date(text)
  if (isNaN(date.getTime()) || date.getTime() <= Date.now() || date.getTime() > Date.now() + 366 * 86400000) return ''
  const pad = n => String(n).padStart(2, '0')
  const exact = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes())
  return exact === text ? text : ''
}
export function syncAiModalLock() {
  document.body.classList.toggle('modal-open', !!document.querySelector('.sheet-layer, .editor.is-expanded'))
}



// WEBPACK FOOTER //
// ./src/common/ai.js